export function createElementForDownloadAll(data: any, name: string) {
	let a = document.createElement('a');
	a.href = URL.createObjectURL(data);
	a.download = name;
	a.click();
	a.remove();
}
